import React, {createContext, useEffect, useState} from "react";
import {authorization} from "../services/authorization.js";
import {getUser} from "../api.js";

export const UserContext = createContext({});

export const Greet = ({children}) => {

  const [isAuth, setIsAuth] = useState(false)
  const [user, setUser] = useState({})

  useEffect(() => {
    if(process.env.REACT_APP_ENV === 'local'){
      setIsAuth(true)
    }else{
      authorization.init().then((data) => {
        if(data.result){
          setIsAuth(true)
        }
      })
    }
  }, [])

  useEffect(() => {
    if(isAuth){
      getUser().then((user) => {
        setUser(user)
      }).catch((error) => console.error(error))
    }
  }, [isAuth]);

  return <UserContext.Provider value={{user, isAuth}}>
    <div className="greet-container">
      <div style={{backgroundColor: user.isCourier ? "darkseagreen" : "coral"}} className="text">
        <div>Hello, {user.full_name}</div>
        <div className="courier-text">{user.isCourier ? "Вы курьер" : "У вас нет прав курьера"}</div>
      </div>
    </div>
    {isAuth && children}
  </UserContext.Provider>
}
